module.exports = __webpack_public_path__ + "media/stylesheets/images/kurashino-791f6488dea1b8e8c481da3fefcb3c19.jpg";